export const MAIL_INFO = '"Smthy" <support@smthy.com>'
export const SEND_MAIL = `${process.env.GATSBY_FIREBASE_CLOUD_FUNCTIONS_BASE_URL}/sendMail`
export const OPERATOR_MAIL = {
  SMTHY: 'smthy.app',
  CODEFABRIC: 'codefabric.io',
}
